/**
 * The design-system widgets: the element a widget of each kind renders as,
 * for whoever renders it — the page renderer (Duro, in the browser) or the
 * design-system sandbox (an uploaded design system). One switch, so a widget
 * kind can't render one way on a page and another in the sandbox.
 */
import type { ReactElement } from "react";

import {
  PrimitiveButton,
  PrimitiveCard,
  PrimitiveHeading,
  PrimitiveIcon,
  PrimitiveInput,
} from "./primitives.js";

/** The kinds a design system renders (the rest are the builder's own). */
export const DS_WIDGET_KINDS = [
  "button",
  "heading",
  "card",
  "input",
  "icon",
] as const;
export type DsWidgetKind = (typeof DS_WIDGET_KINDS)[number];

export const isDsWidgetKind = (k: string): k is DsWidgetKind =>
  (DS_WIDGET_KINDS as readonly string[]).includes(k);

/** The element for a design-system widget's content, or null for any other kind. */
export function dsWidgetElement(
  contentType: string,
  content: Record<string, unknown>,
): ReactElement | null {
  switch (contentType) {
    case "button":
      return <PrimitiveButton {...content} />;
    case "heading":
      return <PrimitiveHeading {...content} />;
    case "card":
      return <PrimitiveCard {...content} />;
    case "input":
      return <PrimitiveInput {...content} />;
    case "icon":
      return <PrimitiveIcon {...content} />;
    default:
      return null;
  }
}
